import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NextConfig } from 'src/app/app-config';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    standalone: false
})

/**
 * Export Class
 */
export class NavBarComponent implements OnInit {
  public nextConfig: any;
  public menuClass: boolean;
  public collapseStyle: string;
  public windowWidth: number;
  @Output() onNavCollapse = new EventEmitter();
  @Output() onNavHeaderMobCollapse = new EventEmitter();
  showLogo: boolean = true;

  /**
  * Constructors
  */
  constructor() {
    this.nextConfig = NextConfig.config;
    this.menuClass = false;
    this.collapseStyle = 'none';
    this.windowWidth = window.innerWidth;
  }

  /**
   * Initial Loader
   */
  ngOnInit() { }

  /**
   * Toggle Mob Option
   */
  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.collapseStyle = (this.menuClass) ? 'block' : 'none';
  }

  /**
   * Nav Collapse
   */
  navCollapse() {
    this.showLogo = !this.showLogo;
    if (this.windowWidth >= 992) {
      this.onNavCollapse.emit();
    } else {
      this.onNavHeaderMobCollapse.emit();
    }
  }
}
